var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteYellowStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0822 16.3386L6.21315 10.4128L0.498047 7.97429L6.42386 6.10524L8.86235 0.390137L10.7314 6.31595L16.4465 8.75444L10.5207 10.6235L8.0822 16.3386Z",
    fill: "#D3EDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3624 19.329L23.3729 16.1918L20.3473 14.9009L23.4845 13.9114L24.7755 10.8857L25.765 14.0229L28.7906 15.3139L25.6534 16.3034L24.3624 19.329Z",
    fill: "#F6DB68"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteYellowStar);
export default __webpack_public_path__ + "static/media/white-yellow-star.7eddc28b1625d626d8140ee68395023b.svg";
export { ForwardRef as ReactComponent };